import React from "react";

import { trashicon } from "../../components/imagepath"; 

const ImgDeleteModal = ({ isVisible, title, description, onCancel, onConfirm }) => {
  if (!isVisible) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center py-4">
              <img
                src={trashicon}
                alt="delete"
                width={50}
                height={46}
                className="mb-3"
              />
              <h5 className="mb-3">{title || "Are you sure?"}</h5>
              <p className="text-muted mb-4">{description}</p>

              <div className="d-flex justify-content-center gap-3">
                <button className="btn btn-primary" onClick={onCancel}>
                  Cancel
                </button>
                <button className="btn btn-quinary" onClick={onConfirm}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImgDeleteModal;
